import Button from "@/common/components/Button"
import GoBackButton from "@/common/components/GoBackButton";
import ReasonModal from "@/common/components/ReasonModal";
import { useGoBack } from "@/common/hooks/useGoBack"
import { useArchivePublicCompanyLead } from "@/features/publicCompanyLeadsFunnel/hooks/useArchivePublicCompanyLead"
import { useIsMutating, useQueryClient } from "@tanstack/react-query"
import { useState } from "react";

interface LeadHeaderProps {
  publicCompanyLeadId: string
  display_name?: string
  url?: string
  showArchiveButton?: boolean
  archived_at?: string
  buttons?: JSX.Element
}

export const LeadHeader = ({
  publicCompanyLeadId,
  display_name,
  url,
  showArchiveButton,
  archived_at,
  buttons,
}: LeadHeaderProps) => {
  const goBack = useGoBack()
  const queryClient = useQueryClient()
  const isMutating = !!useIsMutating()

  const [showReasonModal, setShowReasonModal] = useState(false);

  const archiveUnarchiveOperationKlass = archived_at ? 'Admin::Funnel::Public::Leads::Unarchive' : 'Admin::Funnel::Public::Leads::Archive'

  const {
    mutate: archivePublicCompanyLead,
    isError: archivePublicCompanyLeadIsError,
  } = useArchivePublicCompanyLead({
    publicCompanyLeadId,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['publicCompanyLead', publicCompanyLeadId] })
      goBack({ fallback: '/public-clients' })
    },
  })

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-2 items-center">
          <GoBackButton fallback="/public-clients" searchLastRouteIgnoringFilters />

          {url ? (
            <img
              src={url}
              alt={display_name}
              className="size-10 rounded-full object-cover"
            />
          ) : (
            <div className="size-10 bg-white-800 rounded-full"></div>
          )}
          <p className="text-white-400 font-normal">{display_name}</p>
          {showArchiveButton && (
            <Button
              type="button"
              variant="outline-error"
              operationKlassToCheckPermission={archiveUnarchiveOperationKlass}
              onClick={() => setShowReasonModal(true)}
              disabled={isMutating}
            >
              {archived_at ? 'Desarquivar' : 'Arquivar'}
            </Button>
          )}
        </div>
        {buttons}
      </div>
      {archivePublicCompanyLeadIsError && (
        <p className="text-sm text-danger-soft">Ocorreu um erro no servidor, cheque os campos e tente novamente</p>
      )}
      <ReasonModal
        isOpen={showReasonModal}
        setIsOpen={setShowReasonModal}
        onSubmit={(reasonData) => archivePublicCompanyLead({
          log_reason: reasonData, 
          newStatus: archived_at ? 'unarchive' : 'archive'
        })}
      />
    </div>
  )
}
